import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import appRoutes from '../../../../../../../../app-routes';
import {
  UserRoles,
  NOTIFICATION_MODULE_MENU_LABEL,
} from '../../../../../../../../constraints';

import useFilters from '../../../../../../../../hooks/useFilters';

// Components
import { ProtectedComponent } from '../../../../../../../Auth/components';
import * as Styled from './styled';
import { Grid } from 'billon-ui';

const { Col } = Grid;

const CreateTemplateLargeButton = () => {
  const { filters, navigateWithNewSearchQuery } = useFilters();

  const handleCreateClick = () => {
    navigateWithNewSearchQuery(
      { ...filters },
      appRoutes.NOTIFICATION_TEMPLATE_CREATOR,
    );
  };

  return (
    <ProtectedComponent
      roles={[UserRoles.BUSINESS_ADMIN, UserRoles.ADMIN]}
      render={false}
    >
      <Col lg={4}>
        <Styled.HeaderButton fontWeight={500} onClick={handleCreateClick} block>
          <FormattedMessage
            id={NOTIFICATION_MODULE_MENU_LABEL.TEMPLATE_CREATE_BUTTON}
            defaultMessage={
              NOTIFICATION_MODULE_MENU_LABEL.TEMPLATE_CREATE_BUTTON
            }
          />
        </Styled.HeaderButton>
      </Col>
    </ProtectedComponent>
  );
};

export default CreateTemplateLargeButton;
